<template>
  <div class="message-bubble-wrapper" :class="alignmentClass">
    <div class="message-bubble" :class="bubbleClass">
      <div class="message-header">
        <div class="message-sender">
          <i v-if="message.senderType === 'ai'" class="fa fa-robot"></i>
          <i v-else-if="message.senderType === 'agent'" class="fa fa-user-tie"></i>
          <i v-else class="fa fa-user"></i>
          <span class="sender-label">{{ senderLabel }}</span>
        </div>
        <div v-if="showConfidence" class="ai-confidence" :class="confidenceClass">
          <i class="fa fa-brain"></i>
          <span>{{ (message.aiConfidence * 100).toFixed(0) }}%</span>
          <i v-if="message.aiConfidence < 0.7" class="fa fa-exclamation-triangle text-warning ml-1" v-b-tooltip.hover title="Low confidence - may need review"></i>
        </div>
      </div>
      <div class="message-content">{{ message.content }}</div>
      <div class="message-footer">
        <span class="message-time">{{ formatTime(message.createdAt) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MessageBubble',
  props: {
    message: {
      type: Object,
      required: true,
    },
    agent: {
      type: null
    }
  },
  computed: {
    senderLabel() {

      const classes = {
        customer: 'Customer',
        ai: 'AI assistant',
        system: 'System',
      };
      return classes[this.message.senderType] || this.agent?.name || 'Agent';

    },

    alignmentClass() {
      return this.message.senderType === 'customer' ? 'align-left' : 'align-right';
    },
    bubbleClass() {
      const classes = {
        customer: 'bubble-customer',
        ai: 'bubble-ai',
        agent: 'bubble-agent',
        system: 'bubble-system',
      };
      return classes[this.message.senderType] || 'bubble-default';
    },
    showConfidence() {
      return this.message.senderType === 'ai' && this.message.aiConfidence !== null && this.message.aiConfidence !== undefined;
    },
    confidenceClass() {
      if (!this.showConfidence) return '';
      if (this.message.aiConfidence >= 0.8) return 'confidence-high';
      if (this.message.aiConfidence >= 0.7) return 'confidence-medium';
      return 'confidence-low';
    },
  },
  methods: {
    formatTime(dateTime) {
      if (!dateTime) return '';
      return moment.parseZone(dateTime).format('MMM D, YYYY h:mm A');
    }


  },
};
</script>

<style lang="scss" scoped>
.message-bubble-wrapper {
  display: flex;
  margin-bottom: 1rem;
  animation: fadeIn 0.3s ease-in;

  &.align-left {
    justify-content: flex-start;
  }

  &.align-right {
    justify-content: flex-end;
  }
}

.message-bubble {
  max-width: 70%;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;

  &.bubble-customer {
    background-color: #E2E5EA;
    color: #212529;
    border-bottom-left-radius: 0.25rem;
  }
  .dark-style &.bubble-customer {
    background-color: #41434B!important;
    color: #FFFFFF;
  }

  &.bubble-ai {
    background-color: #007bff;
    color: #ffffff;
    border-bottom-right-radius: 0.25rem;
  }

  &.bubble-agent {
    background-color: #9039B6;
    color: #ffffff;
    border-bottom-right-radius: 0.25rem;
  }

  &.bubble-system {
    background-color: #ffc107;
    color: #212529;
    max-width: 100%;
    text-align: center;
    border-radius: 0.5rem;
    font-style: italic;
  }
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  opacity: 0.9;
}

.message-sender {
  display: flex;
  align-items: center;
  font-weight: 600;

  i {
    margin-right: 0.25rem;
  }
}

.ai-confidence {
  display: flex;
  align-items: center;
  font-size: 0.7rem;

  i {
    margin-right: 0.25rem;
  }

  &.confidence-high {
    color: rgba(255, 255, 255, 0.9);
  }

  &.confidence-medium {
    color: rgba(255, 255, 255, 0.8);
  }

  &.confidence-low {
    color: rgba(255, 255, 255, 0.7);
  }
}

.message-content {
  line-height: 1.5;
  white-space: pre-wrap;
}

.message-footer {
  margin-top: 0.5rem;
  text-align: right;
}

.message-time {
  font-size: 0.7rem;
  opacity: 0.7;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
